import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.salvatorecastelliphotography.it";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_tuscia-wedding-photo/artifacts/l0ii3i9c_DSC_0221-2.webp";

// Per-page SEO meta tags (title, description, canonical, Open Graph)
export const Seo = ({ title, description, path = "/", image = DEFAULT_IMAGE }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
